<template>
  <div class="navbar_wrap hidden-xs-only">
    <div class="navbar_container pc_container">
      <div class="navbar_left">
        <img src="@/assets/images/home/logo_base.png">
        <img src="@/assets/images/home/logo.png"  />
      </div>
      <div class="navbar_right">
        <div class="search_wrap">
          <el-input placeholder="请输入内容" v-model="searchInput" class="input-with-select">
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </div>
       <!--  <span class="right_phone">
          <span style="font-size: 19px; color: #363636;">全国统一热线</span>
          <span style="font-size: 30px; color: #2A59AB;">{{company.tel}}</span>
        </span> -->
      </div>
    </div>
    <div class="navbar_item">
      <div class="navbar_item_container pc_container">
        <el-menu :default-active="activeIndex" class="el_menu_demo"  mode="horizontal" background-color="#2A59AB"
          :text-color="navBackground" :active-text-color="navBackground"  :popper-offset="16"  style="width: 1400px" ellipsis  @select="changeCurrentPage">

          <template v-for="(item, index) in navList" >
            <!-- 有子菜单的 -->
            <el-submenu v-if="item.children && item.children.length > 0" :index="(index+1).toString()" :key="index">
              <template slot="title">
                <span style="font-size:18px;">{{ item.name }}</span>
              </template>
              <el-menu-item-group v-for="(n, i) in item.children" :key="i">
                <el-menu-item :index="(index+1).toString()+'-'+(i+1).toString()" class="menu_item">
                  <template>
                    <span slot="title" style="font-size: 18px;">{{ n.name }} </span>
                </template>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>

            <!-- 没有子菜单的 -->
            <el-menu-item v-else :key="index" :index="(index+1).toString()" class="menu_item">
              <template>
                <span slot="title" style="font-size: 18px;">{{ item.name }}</span></template>
            </el-menu-item>
          </template>
        </el-menu>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: '1',
      navBackground: '#fff',
      searchInput: '',
    }
  },
  props: {
    selectIndex: {
      type: String,
      default: null,
    },
  },
  watch:{
    $route:{
      handler(value){
        if(value){
          if(this.$route.path !== '/search'){
            this.searchInput = ''
            this.$store.commit('keyword','')
          }
          this.navList.forEach((item,index)=>{
            let is_in = false
            if(!item.href.indexOf('http://')>-1 || !item.href.indexOf('https://')>-1){
              if(item.children && item.children.length > 0){//子菜单
                item.children.forEach((cItem)=>{
                  if(value.path === cItem.href){
                    is_in = true
                  }
                })
              }else{
                if(value.path === item.href){//一级菜单
                  is_in  = true
                }
              }
              if(is_in){
                this.activeIndex = (index+1).toString();
                // this.$store.commit('setActiveIndex',index)
              }
              return
            }
          })
        }
      },
      deep:true,
      immediate:true
    },
  },
  computed: {
    navList(){
      return this.$store.state.menu
    },
    company(){
      return this.$store.state.company
    }
  },
  mounted() {
  },
  methods: {
    search() {
      //是当前路由不跳转
      if(!this.searchInput){
        return
      }
      this.$store.commit('setKeyword',this.searchInput)
      if(this.$route.path === '/search'){
        return
      }
      this.$router.replace({ path: '/search'})
    },
    changeCurrentPage(index) {
      this.activeIndex = index+'';
      let firstIndex = null;
      let secondIndex = null;
      let menu = null;
      if(index.indexOf('-')>-1){
        firstIndex = parseInt(index.split('-')[0]) -1 ;
        secondIndex = parseInt(index.split('-')[1]) -1 ;
        this.activeIndex = index.split('-')[0]+'';
        menu = this.navList[firstIndex]['children'][secondIndex];
      }else {
        firstIndex = parseInt(index) - 1;
        menu = this.navList[firstIndex];
      }
      if(menu.target === '_blank'){
        window.open(menu.href)
      }else {
        if(menu.href.indexOf('http://')>-1 || menu.href.indexOf('https://')>-1){
          window.location.href=menu.href;
        }else {
          this.$router.push(menu.href).catch((v) => {})
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>

.navbar_wrap {
  width: 100%;
  height: 180px;
  background: #fff;
  backdrop-filter: saturate(180%) blur(0.5rem);
  display: flex;
  align-items: center;
  flex-direction: column;

  /*position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;*/
  .navbar_container {
    height: 125px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .navbar_left {
      display: flex;
      align-items: center;
      gap: 10px;
      height: 100px;

      img:first-child {
        width: auto;
        height: 65px;
        cursor: pointer;
      }
      img:last-child {
        width: auto;
        height: 100px;
        cursor: pointer;
      }
    }

    .navbar_right {
      display: flex;
      align-items: center;

      .search_wrap {

        .el-input-group__append,
        .el-input-group__prepend {
          background-color: #2A59AB !important;
        }
      }

      .right_phone {
        transition: all 0.5s;
        display: flex;
        flex-direction: column;
        align-items: flex-end;

        i {
          font-size: 20px;
        }

        span {
          margin-left: 0.5rem;
        }

        margin-left: 2rem;
      }
    }
  }

  .navbar_item {
    width: 100%;
    height: 55px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #2A59AB;
    overflow: hidden;

    .navbar_item_container {
      font-size: 18px;
      color: #fff;

      .el_menu_demo {
        border: none;
        display: flex;
        justify-content: space-between;
      }

      .menu_item {
        &:hover {
          font-weight: 600;
          background: #f0f0f0 !important;
          color: #2A59AB !important;
        }
      }
    }
  }

  .el-menu-item {
    padding: 0 19px !important;
    box-sizing: border-box;
  }

  .el-menu-item.is-active {
    background-color: #fff !important;
    color: #2A59AB !important;
  }
}
</style>
